module.exports = __webpack_public_path__ + "img/LogoWhite.2bdb370a.png";